import React, { useEffect, useState } from 'react';
import { getStats } from '../services/api';

function StatsBar({ refreshKey }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getStats()
      .then(setStats)
      .catch(() => setStats(null));
  }, [refreshKey]);

  const total = stats?.totalInspections || 0;
  const avgScore = stats?.averageCompliance || 0;
  const critical = stats?.totalCriticalAlerts || 0;
  const modelStatus = 'COCO-SSD v2';

  return (
    <div className="stats-bar">
      <div className="stat-card">
        <div className="stat-card-icon blue">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
            <path d="M4 3a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 14H6l4-8 3 6 2-4 3 6z"/>
          </svg>
        </div>
        <div className="stat-card-data">
          <span className="stat-card-value">{total}</span>
          <span className="stat-card-label">Total Inspections</span>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-card-icon green">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
            <path d="M11 1L3 5v6c0 5.25 3.4 10.15 8 11 4.6-.85 8-5.75 8-11V5l-8-4zm-1.5 14.5L6 12l1.5-1.5 2 2 5-5L16 9l-6.5 6.5z"/>
          </svg>
        </div>
        <div className="stat-card-data">
          <span className="stat-card-value" style={{ color: avgScore >= 80 ? '#10b981' : avgScore >= 50 ? '#f59e0b' : '#ef4444' }}>
            {avgScore}%
          </span>
          <span className="stat-card-label">Avg Compliance</span>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-card-icon red">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
            <path d="M11 1.5L1.5 19h19L11 1.5zm0 4l6.5 11.5h-13L11 5.5zm-1 5v3h2v-3h-2zm0 4v2h2v-2h-2z"/>
          </svg>
        </div>
        <div className="stat-card-data">
          <span className="stat-card-value" style={{ color: critical > 0 ? '#ef4444' : '#10b981' }}>
            {critical}
          </span>
          <span className="stat-card-label">Critical Alerts</span>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-card-icon purple">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
            <path d="M11 2a9 9 0 100 18 9 9 0 000-18zm0 2a7 7 0 110 14 7 7 0 010-14zm-1 3v2h2V7h-2zm0 4v5h2v-5h-2z"/>
          </svg>
        </div>
        <div className="stat-card-data">
          <span className="stat-card-value" style={{ fontSize: 16 }}>{modelStatus}</span>
          <span className="stat-card-label">AI Model Active</span>
        </div>
      </div>
    </div>
  );
}

export default StatsBar;
